import React from 'react';

const MatchesSpinner = () => (
  <div className="vendor-matches-table__tbody vendor-matches-table__spin">
    <div className="c-loader__spin" data-automation-id="icon:loading" />
    Identifying matches...
  </div>
);

export default MatchesSpinner;
